import React from 'react';
import { useNavigate } from 'react-router-dom';
import SentimentVeryDissatisfiedIcon from '@mui/icons-material/SentimentVeryDissatisfied';
import HomeIcon from '@mui/icons-material/Home';

const NotFound: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="not-found">
      <h1>404</h1>
      <SentimentVeryDissatisfiedIcon className="sad-icon" />
      <h2>Oops! Looks like this page took a wrong turn</h2>
      <p>Maybe it's updating its resume somewhere else?</p>
      <p className="subtitle">Don't worry, we'll help you get back on track!</p>
      <button 
        onClick={() => navigate('/')}
        className="home-button"
      >
        <HomeIcon /> Take me home
      </button>
    </div>
  );
};

export default NotFound; 